import React, { useState } from 'react';
import { Wrapper, Menu, Button, MenuItem } from 'react-aria-menubutton';
import styled from 'styled-components/macro';
import ArrowIcon from '../components/svg/Arrow';
import { getIdHistorico, getUrl, parseaFechaHora } from '../utils';
import { useTranslate } from '../contexts/languageContext';
import { useIsMobile } from '../hooks/useMediaQuery';
/**
 * Dropdown que nos permite acceder a la página de histórico para el ámbito en el que nos encontremos
 */

const Dropdown = ({
  data,
  items,
  id,
  eleccion,
  nomenclator,
  className = '',
  defaultSelectedId,
  hasSelectedItem,
  openOnMount,
  page,
  tope,
  parentLevel,
}) => {
  const [isOpen, setIsOpen] = useState(openOnMount);
  const esBoletin = tope === '1' || data.amb.length >= 9;
  const t = useTranslate();
  const isMobile = useIsMobile();
  const filtered = [];
  if(items && items.length !== 0){
    for(let i = 0; i < items.length; i++) {
      const found = filtered.findIndex(item => item.numact === items[i].numact);
      if(found !== -1){
       if(Number(items[i].mdhm) > Number(filtered[found].mdhm))
        filtered[found] = items[i];
      }else{
       filtered.push(items[i]);
     }
    };
  }
  return filtered && filtered.length !== 0 ? (
    <StyledWrapper
      onSelection={({
        id,
        eleccion,
        nomenclator,
        page,
        idHistorico,
        parentLevel,
        item,
        tope,
      }) => {
        window.open(
          getUrl({
            id,
            eleccion,
            nomenclator,
            page,
            idHistorico,
            parentLevel,
          }),
          'newwindow'
        );
      }}
      onMenuToggle={({ isOpen }) => setIsOpen(isOpen)}
    >
      <StyledButton>
        <span>{`${esBoletin ? t('boletin') : t('avance')} ${
          data.numact
        }`}</span>
        <ContainerArrow>
        <ArrowIcon
          css="padding-left: 10px"
          variant={isOpen ? 'up' : 'down'}
          fill={isMobile ? "#000" : "#fff"}
        />
        </ContainerArrow>
      </StyledButton>
      <StyledMenu>
        <Title>
          {esBoletin ? t('historicoDeBoletines') : t('historicoDeAvances')}
        </Title>
        <Ul>
          {filtered.map(item => {
            const idHistorico = getIdHistorico(item.numdep, tope);
            return (
              <li key={item.numact}>
                <SMenuItem
                  value={{
                    id,
                    eleccion,
                    nomenclator,
                    page,
                    idHistorico,
                    item,
                    parentLevel,
                  }}
                  text={item.numact}
                >
                  <StyledAnchor
                    target="_blank"
                    rel="noopener noreferrer"
                    href={getUrl({
                      id,
                      eleccion,
                      nomenclator,
                      page,
                      idHistorico,
                      parentLevel,
                    })}
                    onClick={e => e.preventDefault()}
                    tabIndex="-1"
                  >{`${esBoletin ? t('boletin') : t('avance')} ${
                    data.amb.length >= 9 ? "9999" : item.numact
                  } - ${parseaFechaHora(item.mdhm)}`}</StyledAnchor>
                </SMenuItem>
              </li>
            );
          })}
        </Ul>
      </StyledMenu>
    </StyledWrapper>
  ) : (
    <StyledText>
      <span>{`${esBoletin ? t('boletin') : t('avance')} ${ data.amb.length >= 9 ? "9999" : item.numact}`}</span>
    </StyledText>
  );
};
export default Dropdown;

const Title = styled.div`
  font-weight: 500;
  color: #000000;
`;
const StyledWrapper = styled(Wrapper)`
  position: relative;
  box-sizing: border-box;
  display: flex;
  min-width: 130px;
  max-width: 150px;
  flex-grow: 0;
  @media (max-width: 768px) {
    margin-left: auto;
    width: 100%;
    justify-content: flex-end;
  }
`;

const StyledMenu = styled(Menu)`
  position: absolute;
  z-index: 1;
  top: 70px;
  background: white;
  padding: 20px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  left: -134px;
  min-width: 250px;
  max-height: 250px;
  ::before {
    content: '';
    display: inline-block;
    position: absolute;
    left: calc(50% + 55px);
    top: -20px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent white;
    @media (max-width: 768px) {
      right: 20px;
      left: initial;
    }
  }
  @media (max-width: 768px) {
    max-height: 235px;
    max-width: 90vw;
    right: 20px;
    left: initial;
  }
`;

const Ul = styled.ul`
  overflow: auto;
  background: white;
  box-sizing: border-box;
  max-height: 195px;
  @media (max-width: 768px) {
    max-height: 175px;
  }
`;

const StyledButton = styled(Button)`
  font-weight: 100;
  font-size:16px;
  text-transform: camelCase;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  line-height: 1.3;
  cursor: pointer;
  user-select: none;
  justify-content: center;
  &.focus-visible {
    text-decoration: underline !important;
    outline: none !important;
  }
  padding: 14px;
  border-radius: 4px;
  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;

const StyledAnchor = styled.a`
  display: block;
  width: 100%;
  line-height: 2em;
`;
const StyledText = styled.div`
  font-weight: bold;
  text-transform: uppercase;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 200px;
  @media (max-width: 768px) {
    margin-left: auto;
  }
`;
const ContainerArrow = styled.span`
@media print {
  display: none;
}
`;


const SMenuItem = styled(MenuItem)`
  cursor: pointer;
  font-size: 12px;
  > a {
    color: #283f5f;
  }
  @media (max-width: 768px) {
    padding: 5px 0;
  }

  &.focus-visible {
    text-decoration: underline !important;
    outline: none !important;
  }
  :hover {
    a {
      text-decoration: underline;
    }
  }
`;
